import { h, Component } from 'preact';
import Store from 'store/store';

import s from 'components/shared/cookies/banner.sss';

export default class Banner extends Component {
	constructor(props) {
		super(props);
		this.onResize = this.onResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.onResize();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		let header = document.querySelector('header');
		if (header) {
			header.style.top = '';
			document.body.style.paddingTop = '';
		}
	}

	onResize() {
		if (!this.base) {
			return;
		}
		let height = this.base.clientHeight;
		if (height === this.headerTop) {
			return;
		}
		this.headerTop = height;
		let header = document.querySelector('header');
		if (!header) {
			return;
		}
		header.style.top = height + 'px';
		document.body.style.paddingTop = height + 'px';
	}

	openPrivacy(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		Store.emit('SET_ACTIVE_PAGE', 'privacyPolicy');
	}

	acceptAllCookies() {
		Store.emit('ACCEPT_ALL_COOKIES');
	}

	toggleCookiePreferenceCenter() {
		Store.emit('TOGGLE_COOKIES_PREFERENCE_CENTER');
	}

	render() {
		return (
			<div class={s.box}>
				<p class={s.text}>
					We use cookies to ensure the best experience and some are necessary for our site to work. Read our cookie policy
					<a class={s.privacyLink} href="/privacy/" onClick={this.openPrivacy}>here</a>
				</p>
				<div class={s.buttons}>
					<button class={s.accept} onClick={this.acceptAllCookies}>
						Accept
					</button>
					<button class={s.manage} onClick={this.toggleCookiePreferenceCenter}>
						Manage Cookies
					</button>
				</div>
			</div>
		);
	}
}
